import { render } from "./MinusIcon.vue?vue&type=template&id=283086c4"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"
script.render = render

export default script